module.exports = __webpack_public_path__ + "img/computer-qualitative.205a4bed.svg";